import integrationModule from "./integrationModule"
import {R2VehicleDefaultMaxValuesType} from "./R2VehicleDefaultMaxValuesType"

const IntegrationDataSourceDetail = {
    "TRIP_RELEASE": 607602837,
    "TRIP_UNRELEASE": 607602861,
    "RELEASED_TRIP_CANCEL": 626940653,
    "ROUTING_SESSION": 1064397345
}

integrationModule.controller("integrationController", ["$scope", "integrationService", "loadingService", "messagesModal", "remoteExceptionHandler",
    function ($scope, integrationService, loadingService, messagesModal, remoteExceptionHandler) {

        $scope.integrationConfig = {}
        $scope.changeCredentials = function (record) {
            record.credentialChanged = true
        }

        $scope.getPublishingTypes = function () {
            return integrationService.getPublishingTypes()
        }

        $scope.quantityFormats = [
            "br.com.neolog.r2.model.R2IntegrationQuantityFormats.UNITARY",
            "br.com.neolog.r2.model.R2IntegrationQuantityFormats.VARIED_BY_PRODUCT"
        ]

        $scope.weightUnits = [
            "br.com.neolog.r2.model.R2IntegrationWeightUnits.NO_WEIGHT",
            "br.com.neolog.r2.model.R2IntegrationWeightUnits.TONNE",
            "br.com.neolog.r2.model.R2IntegrationWeightUnits.KILOGRAMS"
        ]

        $scope.volumeUnits = [
            "br.com.neolog.r2.model.R2IntegrationVolumeUnits.NO_VOLUME",
            "br.com.neolog.r2.model.R2IntegrationVolumeUnits.LITER",
            "br.com.neolog.r2.model.R2IntegrationVolumeUnits.CUBIC_METER"
        ]

        $scope.vehicleMaxValuesTypeVolume = R2VehicleDefaultMaxValuesType.VOLUME
        $scope.vehicleMaxValuesTypeWeight = R2VehicleDefaultMaxValuesType.WEIGHT

        $scope.detailsTableOptions = {
            columns: [{
                header: "",
                cell: {
                    template: "<nlg-tdn-help doc-id='{{record.documentation}}' ng-if='record.documentation'></nlg-tdn-help>"
                },
                width: "10px",
                textAlign: "center",
                cellName: "integrationTaskHelp"
            }, {
                header: "edition.integrationDataSource.name",
                cell: "{{ getTypeBundle(record.task.type) | translate}}",
                width: "25%",
                cellName: "integrationTaskName"
            }, {
                header: "edition.integrationDataSource.url",
                cell: {
                    type: "text",
                    model: "record.url"
                },
                width: "30%",
                cellName: "integrationTaskURL"
            }, {
                header: "edition.integrationDataSource.maxResponseWait",
                cell: {
                    type: "number",
                    min: "10000",
                    decimals: "0",
                    model: "record.timeout"
                },
                width: "135px",
                cellName: "integrationTaskResponseMaxWait"
            }, {
                header: "edition.integrationDataSource.isAuthenticatedService",
                cell: {
                    type: "checkbox",
                    model: "record.authService",
                    click: "toggleAuthService(record)"
                },
                textAlign: "center",
                width: "125px",
                cellName: "integrationTaskAuthService"
            }, {
                header: "edition.integrationDataSource.user",
                cell: {
                    type: "text",
                    model: "record.authUsername",
                    ngDisabled: "! record.authService",
                    change: "changeCredentials(record)"
                },
                width: "150px",
                cellName: "integrationTaskAuthUser"
            }, {
                header: "edition.integrationDataSource.password",
                cell: {
                    template: `<input type="password"
                    ng-model="record.authPassword"
                    ng-disabled="!record.authService"
                    ng-change="changeCredentials(record)"
                    ng-attr-placeholder="{{getPlaceholder(record)}}"
                    class="form-control">`
                },
                width: "150px",
                cellName: "integrationTaskAuthPassword"
            }]
        }


        $scope.getPlaceholder = function (record) {
            if (record.authUsername !== null && record.authUsername !== " " && !record.credentialChanged) {
                return "******"
            } else {
                return " "
            }
        }


        $scope.toggleAuthService = function (record) {
            if (!record.authService) {
                record.authUsername = null
                record.authPassword = null
            }
        }

        $scope.getTypeBundle = function (taskType) {
            return "edition.integrationDataSource." + taskType
        }

        $scope.setDefaultValueForVehicleMaxValuesType = function() {
            if($scope.integrationConfig.r2VehicleDefaultMaxValues.r2VehicleDefaultMaxValuesType === null || $scope.integrationConfig.r2VehicleDefaultMaxValues.r2VehicleDefaultMaxValuesType === undefined) {
                $scope.integrationConfig.r2VehicleDefaultMaxValues.r2VehicleDefaultMaxValuesType = R2VehicleDefaultMaxValuesType.VOLUME
            }
        }

        $scope.setDefaultValueForVehicleMaxValuesDefaultValue = function () {
            if($scope.integrationConfig.r2VehicleDefaultMaxValues.defaultValue === null ||
                $scope.integrationConfig.r2VehicleDefaultMaxValues.defaultValue === undefined ||
                $scope.integrationConfig.r2VehicleDefaultMaxValues.defaultValue === 0.001) {
                $scope.integrationConfig.r2VehicleDefaultMaxValues.defaultValue = 100000
            }
        }

        function getConfig() {
            return loadingService(integrationService.getIntegrationConfig()).then((config) => {
                $scope.integrationConfig = config
                $scope.detailsTableOptions.records = config.dataSourceDetails
                    .map(detail => {
                        detail.documentation = IntegrationDataSourceDetail[detail.task.type]
                        return detail
                    })
            })
        }

        getConfig()

        $scope.save = function () {
            loadingService(integrationService.createOrUpdateConfig($scope.integrationConfig))
                .catch(remoteExceptionHandler())
                .then(() => getConfig())
                .then(() => {
                    messagesModal("dialog.success", [{
                        keyBundle: "entity.validator.successMessage",
                        parameters: []
                    }])
                })
        }
    }])